import { useMutation } from "@tanstack/react-query";
import { changeBroadcastStatus } from "../api/changeBroadcastStatus";
import { Status } from "../types";

type Params = {
  broadcastId: string;
  status: Status;
};

export const useChangeBroadcastStatusQuery = () => {
  return useMutation({
    mutationFn: async ({ broadcastId, status }: Params) => {
      return await changeBroadcastStatus(broadcastId, status);
    },
    onError: (e) => console.error(e),
  });
};
